import { render, staticRenderFns } from "./buildDetail.vue?vue&type=template&id=1dad2b94&scoped=true"
import script from "./buildDetail.vue?vue&type=script&lang=js"
export * from "./buildDetail.vue?vue&type=script&lang=js"
import style0 from "./buildDetail.vue?vue&type=style&index=0&id=1dad2b94&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dad2b94",
  null
  
)

export default component.exports